import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                model: 'global_settings',
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                panel: {
                    home: {
                        title: null,
                        news: {
                            title: 'Destaques',
                            slider: 4,
                            order: 1,
                        },
                        modules: {
                            title: 'Módulos',
                            limit: 6,
                            order: 2,
                        }
                    },
                    news: {
                        title: 'Notícias',
                        per_page: 2,
                    },
                },
                acl: {
                },
            },
            dashboard: {
                menu: {
                    route: `${code}.dashboard`,
                    text: 'dashboard.title',
                    icon: 'fas fa-th-large',
                },
                acl: {
                    view: null,
                },
            },
            profile: {
                menu: {
                    route: `${code}.profile`,
                    text: 'auth.profile',
                    icon: 'far fa-circle-user',
                },
                acl: {
                    view: 'GP_10001',
                    detail: 'GP_10001',
                    edit: 'GP_10002',
                },
                url: {
                    show: '/auth/profile',
                    update: '/auth/profile',
                },
            },
            // framework: {
            //     menu: {
            //         route: `${code}.framework`,
            //         text: 'framework.title',
            //         icon: 'fas fa-circle-info',
            //     },
            //     acl: {
            //         view: null,
            //     },
            // },
            about: {
                menu: {
                    route: `${code}.about`,
                    text: 'about.title',
                    icon: 'fas fa-glasses',
                },
                acl: {
                    view: null,
                },
            },
            news: {
                acl: { },
                url: {
                    getLast: 'geoportal/front/:locale/news/last',
                    getArchive: 'geoportal/front/:locale/news/archive?page=:page',
                    getSingle: 'geoportal/front/:locale/news/single/:slug/:preview',
                },
            },
            pages: {
                acl: { },
                url: {
                    getSingle: 'geoportal/front/pages/:slug',
                },
            },
            search: {
                acl: { },
                url: {
                    getResults: 'geoportal/front/search?q=:searchTerm',
                },
            },
            contact: {
                menu: {
                    route: `${code}.contact-us`,
                    text: 'contact.title',
                    icon: 'fas fa-phone',
                },
                url: {
                    sendMessage: `${codeAPI}/notifications/contact`,
                },
            },
            resendverificationemail: {
                url: {
                    send: `/auth/email/resend`,
                },
            },
            resetpassword: {
                url: {
                    sendEmail: `/auth/password/email`,
                    reset: `/auth/password/reset`,
                },
            },

        },
        tools: {
        },
        config: {

        },
    },
};

export default state;
